/**
 * Horizontal carousel
 */
(function () {
  function getScrollStep(track) {
    const slide = track.querySelector('.carousel__slide');
    if (!slide) return 300;

    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function initCarousel(carousel) {
    const track = carousel.querySelector('[data-carousel-track]');
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const progress = carousel.querySelector('[data-carousel-progress]');
    if (!track) return;

    function updateProgress() {
      if (!progress) return;
      const max = track.scrollWidth - track.clientWidth;
      const pct = max > 0 ? (track.scrollLeft / max) * 100 : 100;
      progress.style.width = `${Math.max(10, pct)}%`;
    }

    function updateButtons() {
      const max = track.scrollWidth - track.clientWidth;
      const atStart = track.scrollLeft <= 1;
      const atEnd = track.scrollLeft >= max - 1;

      if (prev) prev.disabled = atStart || max <= 0;
      if (next) next.disabled = atEnd || max <= 0;
    }

    function update() {
      updateProgress();
      updateButtons();
    }

    if (carousel.dataset.carouselInit !== 'true') {
      carousel.dataset.carouselInit = 'true';

      prev?.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollStep(track), behavior: 'smooth' });
      });

      next?.addEventListener('click', () => {
        track.scrollBy({ left: getScrollStep(track), behavior: 'smooth' });
      });

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      carousel.addEventListener('carousel:refresh', update);
    }

    carousel._carouselUpdate = update;
    update();
  }

  document.querySelectorAll('[data-carousel]').forEach(initCarousel);
})();
